function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _excluded = ["displayHorizontal", "justifyTabs", "skin", "isLightColor", "className", "defaultActiveTab", "renderActiveTabOnly", "getActiveTabIndex", "activeTabIndex"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import { number, node, bool, string, func, oneOf } from 'prop-types';
import classNames from 'classnames';
import uuid from 'uuid';
import './Tabs.scss';
var propTypes = {
  /** Set the tab you want to be open by default. (Zero-based index: First tab is 0, second tab is 1, ...) */
  defaultActiveTab: number,

  /** Controll  */
  activeTabIndex: number,

  /** Use the `<Tab>` component as children of `<Tabs>`*/
  children: node,

  /** Displays the tabs to the left of the content */
  displayHorizontal: bool,

  /** Makes the tabs fill the whole width of the parent */
  justifyTabs: bool,

  /** Choose a skin to your tabs */
  skin: oneOf(['dark', 'light', 'neutral']),

  /** @deprecated Use `skin` instead */
  isLightColor: bool,

  /** Add your own custom class names to the component */
  className: string,

  /** Callback function that returns the index number of the active tab */
  getActiveTabIndex: func,

  /** Choose if you want to render only the active tab to the DOM */
  renderActiveTabOnly: bool
};
var defaultProps = {
  skin: 'dark',
  defaultActiveTab: 0,
  getActiveTabIndex: function getActiveTabIndex() {}
};
/** The Tabs component keeps related content together in the same location. The user can show or hide content by navigating through the tabs. */

var Tabs = /*#__PURE__*/function (_Component) {
  _inherits(Tabs, _Component);

  var _super = _createSuper(Tabs);

  function Tabs(props, context) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _super.call(this, props, context);
    var tabIds = [];
    React.Children.forEach(props.children, function () {
      tabIds = [].concat(_toConsumableArray(tabIds), [uuid.v4()]);
    });
    _this.state = {
      activeTabIndex: _this.props.defaultActiveTab,
      tabIds: tabIds
    };
    _this.handleTabClick = _this.handleTabClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Tabs, [{
    key: "handleTabClick",
    value: function handleTabClick(tabIndex) {
      var _this2 = this;

      this.setState({
        activeTabIndex: tabIndex === this.state.activeTabIndex ? this.state.activeTabIndex : tabIndex
      }, function () {
        return _this2.props.getActiveTabIndex(_this2.state.activeTabIndex);
      });
    }
  }, {
    key: "renderChildrenWithProps",
    value: function renderChildrenWithProps() {
      var _this3 = this;

      return React.Children.map(this.props.children, function (child, index) {
        return /*#__PURE__*/React.cloneElement(child, {
          onClick: function onClick() {
            return _this3.handleTabClick(index);
          },
          id: _this3.state.tabIds[index],
          isActive: index === _this3.state.activeTabIndex
        });
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this4 = this;

      if (this.props.activeTabIndex !== prevProps.activeTabIndex) {
        this.setState({
          activeTabIndex: this.props.activeTabIndex
        }, function () {
          return _this4.props.getActiveTabIndex(_this4.state.activeTabIndex);
        });
      }
    }
  }, {
    key: "renderTabPanels",
    value: function renderTabPanels() {
      var _this5 = this;

      var children = this.props.children;

      if (React.Children.count(children) > 1) {
        return children.map(function (child, index) {
          return /*#__PURE__*/React.createElement("div", {
            className: "rds-tabs__content",
            role: "tabpanel",
            "aria-hidden": index !== _this5.state.activeTabIndex,
            key: _this5.state.tabIds[index],
            id: "rds-tab-panel-".concat(_this5.state.tabIds[index]),
            "aria-labelledby": "".concat(_this5.state.tabIds[index])
          }, child.props.children);
        });
      } else {
        return /*#__PURE__*/React.createElement("div", {
          className: "rds-tabs__content",
          role: "tabpanel",
          "aria-hidden": 0 !== this.state.activeTabIndex,
          id: "rds-tab-panel-".concat(this.state.tabIds[0]),
          "aria-labelledby": "".concat(this.state.tabIds[0])
        }, children.props.children);
      }
    }
  }, {
    key: "renderOnlyActiveTabPanel",
    value: function renderOnlyActiveTabPanel() {
      var _this6 = this;

      var children = this.props.children;

      if (React.Children.count(children) > 1) {
        return children.map(function (child, index) {
          return index === _this6.state.activeTabIndex && /*#__PURE__*/React.createElement("div", {
            className: "rds-tabs__content",
            role: "tabpanel",
            "aria-hidden": index !== _this6.state.activeTabIndex,
            key: _this6.state.tabIds[index],
            id: "rds-tab-panel-".concat(_this6.state.tabIds[index]),
            "aria-labelledby": "".concat(_this6.state.tabIds[index])
          }, child.props.children);
        }); //If there is only one child
      } else {
        return /*#__PURE__*/React.createElement("div", {
          className: "rds-tabs__content",
          role: "tabpanel",
          "aria-hidden": 0 !== this.state.activeTabIndex,
          id: "rds-tab-panel-".concat(this.state.tabIds[0]),
          "aria-labelledby": "".concat(this.state.tabIds[0])
        }, children.props.children);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          displayHorizontal = _this$props.displayHorizontal,
          justifyTabs = _this$props.justifyTabs,
          skin = _this$props.skin,
          isLightColor = _this$props.isLightColor,
          className = _this$props.className,
          defaultActiveTab = _this$props.defaultActiveTab,
          renderActiveTabOnly = _this$props.renderActiveTabOnly,
          getActiveTabIndex = _this$props.getActiveTabIndex,
          activeTabIndex = _this$props.activeTabIndex,
          rest = _objectWithoutProperties(_this$props, _excluded);

      var componentClassNames = classNames('rds-tabs', {
        'rds-tabs--horizontal': displayHorizontal,
        'rds-tabs--justify-tabs': justifyTabs,
        '': skin === 'dark' || skin === '' || !skin || skin === 'default',
        'rds-tabs--light': skin === 'light',
        'rds-tabs--neutral': skin === 'neutral'
      }, className);

      if (isLightColor) {
        console.error('The isLightColor prop is deprecated. Please use the skin prop instead');
      }

      return /*#__PURE__*/React.createElement("div", _extends({
        className: componentClassNames
      }, rest), /*#__PURE__*/React.createElement("ul", {
        className: "rds-tabs__tab-list"
      }, this.renderChildrenWithProps()), renderActiveTabOnly ? this.renderOnlyActiveTabPanel() : this.renderTabPanels());
    }
  }]);

  return Tabs;
}(Component);

Tabs.propTypes = propTypes;
Tabs.defaultProps = defaultProps;
export default Tabs;